<template>
  <div class="success-wrapper">
    <div class="title-wrapper">
      <div class="img-wrapper">
        <img src="@/images/couponPack/success.png" alt="" />
      </div>
      <span class="title">支付成功</span>
    </div>
    <div class="btns-wrapper">
      <div class="btn btn-left" @click="handleGoToCoupon">查看我的优惠券</div>
      <div class="btn btn-right" @click="handleGoTo">继续逛逛</div>
    </div>
  </div>
</template>
<script>
import { nativeRedirect } from '@/utils/native_interactions/native_redirect'
import { nativeRoutes } from '@/utils/native_interactions/native_redirect/routes'
import { navBar } from '@/utils/native_interactions/native_bar'
export default {
  beforeRouteEnter(to, from, next) {
    next(v => {
      navBar.setTitle({
        text: '支付结果'
      })
    })
  },
  methods: {
    handleGoTo() {
      this.$router.go(-3)
    },
    handleGoToCoupon() {
      nativeRedirect(nativeRoutes.myCoupons)
    }
  }
}
</script>
<style lang="scss" scoped>
.success-wrapper {
  padding-top: 1.86rem;
  .title-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    .img-wrapper {
      width: 0.77rem;
      img {
        width: 100%;
      }
    }
    .title {
      margin-left: 0.22rem;
      color: #333;
      font-size: 0.4rem;
    }
  }
  .btns-wrapper {
    margin-top: 0.74rem;
    display: flex;
    justify-content: center;
    .btn {
      width: 2.62rem;
      height: 0.8rem;
      line-height: 0.8rem;
      text-align: center;
      border-radius: 0.12rem;
      border: 1px solid rgba(204, 204, 204, 0.5);
      &-right {
        margin-left: 0.4rem;
      }
    }
  }
}
</style>
